export enum TrainingTargetType {
  everyone = "everyone",
  store = "stores",
  groups = "groups",
  roles = "roles",
}
